import React from 'react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true, info })
    // You can also log the error to an error reporting service
    console.log(error, info)
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div>
          <h1>Something went wrong.</h1>
          <If condition={this.state.info && this.state.info.componentStack}>
            <pre>{this.state.info.componentStack}</pre>
          </If>
        </div>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary



// WEBPACK FOOTER //
// ./ui/DevError/ErrorBoundary.js